module.exports = __webpack_public_path__ + "media/images/posts/karaoke-e0a2d88b0ee031f1113b6e8364eae7eb.jpg";